export const authAPI = {
    login: '/auth/sign-in',
    verifyOtp: '/auth/verification',
    resendOtp: '/auth/resend-verification',
    me: '/affiliates/me',
    updateInfo: '/affiliates/me',
    logout: '/logout',
    agreeToTerms: '/affiliates/agreeToTerms',
    isAgreedToTerms: 'affiliates/isAgreedTos',
};

export const affiliateAPI = {
    affiliateRegistration: '/affiliates/',
    changePass: '/affiliates/password',
    resendVerification: '/affiliates/resend',
    verificationEmail: '/affiliates/verified',
    updatePassword: '/affiliates/password',
    meReport: '/affiliates/me/mya/reports',
    casinoReport: '/affiliates/me/mya/casinoreports',
    exportReport: '/affiliates/export/achievementreport',
    meMonthlyReport: '/affiliates/me/mya/monthlyreports',
    exportMeMonthlyReport: '/affiliates/me/mya/exportmonthlyreports',
    meReportRows: '/affiliates/me/mya/reportsrows',
};

export const campaignAPI = {
    campaignList: '/campaign/',
    saveGroup: '/campaign/groups/save',
    saveCampaign: '/campaign/save',
};

export const commonsAPI = {
    fetchQuestCpaCasinos: '/affiliates/search',
    fetchServices: '/services/',
    fetchNotesCategory: '/notes/category',
    findAffByIdOrEmail: '/admin/affiliates/list',
    getAllServices: '/services/all',
    getAllCasino: '/affiliates/brands',
    getAccountTypes: '/affiliates/me/accounts/types',
    getAdsType: '/advertisements/categories/',
    campaignGroups: '/campaign/groups',
    saveReferrerLog: '/advertisements/save-referrer',
    localization: '/affiliates/localization',
    getAdsCategory: '/advertisements/advertisement-categories/',
};

export const adsAPI = {
    getAds: 'advertisements/mya/adslinks',
    getAdsList: '/advertisements/',
    campaignList: '/campaign/',
    getAdsByID: '/advertisements/#adsID',
    getLandingPages: '/advertisements/landingpage/',
    getLandingPageByID: '/advertisements/landingpage/#landingPageID',
    saveClick: '/advertisements/trackclick/#adsID',
    getAdsStats: 'advertisements/mya/adsStats',
    exportMediaTraffic: 'advertisements/exportMediaTraffic',
};

export const referralAPI = {
    getReferral: '/tiers/getReferralMasterLink',
    saveReferralMaster: '/tiers/saveReferralMaster',
};

export const tierReportAPI = {
    getTierReport: '/affiliates/me/mya/tierreports',
    getTierReportChart: '/affiliates/me/mya/tiergraph',
};

export const updateInfoAPI = {
    updateInfo: '/affiliates/mya/me',
    getCurrentPaymentGET: '/affiliates/mya/accounts/paymentdetail',
    createUpdatePaymentAccountPUT: '/affiliates/mya/accounts/paymentdetails',
    updatePaymentThreshold: '/affiliates/mya/me/threshold',
};

export const cpaAPI = {
    getrewardplans: '/commissionsets/rewardplans/',
};

export const transactionsModuleAPI = {
    getTransactions: 'affiliates/affiliatetransactions',
    exportTransactions: 'affiliates/affiliatetransactions/export',
};

export const playersModuleAPI = {
    getSales: 'player/daysales',
    exportPlayerSales: 'player/export/playersales',
};

export const introductionAPI = {
    getBeginnersGuide: 'affiliates/mya/getBeginnersGuide',
    getListBeginnersGuide: 'affiliates/mya/beginnersGuideList',
};

export const newsBannerAPI = {
    getActiveNews: '/news/active-news-management',
};
